import * as React from "react";
import generatePdfThumbnails from "pdf-thumbnails-generator";

export default function FileThumnail({
  pdfFile,
  width = "100%",
  height = "auto",
}) {
  // console.log("pdfFile::", pdfFile);

  const [thumnail, setThumnail] = React.useState("");

  async function generateThumbnails(pdf) {
    try {
      // const file = await urlToObject(pdfFile)
      let thumbnails = await generatePdfThumbnails(pdf, 200);
      // console.log("thumbnails::", thumbnails);
      setThumnail(thumbnails[0].thumbnail);
    } catch (err) {
      console.error(err, "err document");
    }
  }

  React.useEffect(() => {
    if (pdfFile) {
      generateThumbnails(pdfFile);
    }
  }, [pdfFile]);

  return (
    <img
      src={thumnail}
      alt="document"
      style={{
        width: width,
        height: height,
        objectFit: "cover",
        borderRadius: "4px",
      }}
      className="thumbnail-img"
    />
  );
}

// import * as React from "react";
// import * as pdfjsLib from "pdfjs-dist";

// pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.REACT_APP_END_POINT}/pdf.worker.min.mjs`;

// export default function FileThumnail({
//   pdfFile,
//   width = "100%",
//   height = "auto",
// }) {
//   const [thumbnail, setThumbnail] = React.useState("");

//   React.useEffect(() => {
//     if (!pdfFile) {
//       setThumbnail("");
//       return;
//     }

//     let cancelled = false;
//     let loadingTask;

//     const generateThumbnail = async () => {
//       try {
//         loadingTask = pdfjsLib.getDocument({ url: pdfFile });

//         // Use the promise property, not loadingTask.then()
//         const pdf = await loadingTask.promise;
//         const page = await pdf.getPage(1);
//         const viewport = page.getViewport({ scale: 0.5 });

//         const canvas = document.createElement("canvas");
//         const context = canvas.getContext("2d");

//         if (!context) {
//           throw new Error("Unable to create canvas context");
//         }

//         canvas.width = viewport.width;
//         canvas.height = viewport.height;

//         await page.render({
//           canvasContext: context,
//           viewport,
//         }).promise;

//         if (!cancelled) {
//           setThumbnail(canvas.toDataURL("image/png"));
//         }
//       } catch (error) {
//         if (!cancelled) {
//           console.error("PDF thumbnail error:", error);
//           setThumbnail("");
//         }
//       }
//     };

//     generateThumbnail();

//     return () => {
//       cancelled = true;
//       loadingTask?.destroy();
//     };
//   }, [pdfFile]);

//   return thumbnail ? (
//     <img
//       src={thumbnail}
//       alt="PDF thumbnail"
//       style={{
//         width,
//         height,
//         objectFit: "cover",
//         borderRadius: "4px",
//       }}
//       className="thumbnail-img"
//     />
//   ) : (
//     <div
//       style={{
//         width,
//         height,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       PDF preview unavailable
//     </div>
//   );
// }
